import { tabelaInternalizacaoStyles } from './TabelaInternalizacao.style'

export function tabelaInternalizacaoIO() {
  return {
    styles: tabelaInternalizacaoStyles
  }
}

export type TabelaInternalizacaoIO = ReturnType<typeof tabelaInternalizacaoIO>
